import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ChatMentionsPipe } from "./chat-mentions.pipe";

@NgModule({
	imports: [CommonModule],
	declarations: [ChatMentionsPipe],
	exports: [ChatMentionsPipe]
})
export class ChatMentionsModule { }
